import React from "react";
import "../index.css";
import { icons } from "../../../../../svg";

interface StatusPanelProps {
  originName: string;
  onClose: () => void;
  title: string;
  message: React.ReactNode; // Can be string or JSX paragraphs
  buttonText: string;
}

const StatusPanel: React.FC<StatusPanelProps> = ({
  originName,
  onClose,
  title,
  message,
  buttonText,
}) => {
  const isError = title.includes("Oops");

  return (
    <div className="status-panel-container">
      <div className="selected-origin-box">
        <div>
          <span className="selected-origin-label">Selected Origin</span>
          <span className="selected-origin-value">{originName}</span>
        </div>
      </div>

      <div className="status-card">
        <div className="checkmark-icon-wrapper">
          {isError ? (
            <img
              data-tooltip-id="ExclamationMark"
              src={icons.ExclamationMark}
              alt="ExclamationMark"
              className="icon"
            />
          ) : (
            <img
              data-tooltip-id="GreenCheckMarkWithBackground"
              src={icons.GreenCheckMarkWithBackground}
              alt="Success"
              className="icon"
            />
          )}
        </div>
        <h2 className="status-title">{title}</h2>
        <div className="status-description">{message}</div>
        <button type="button" className="close-button" onClick={onClose}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default StatusPanel;
